import ProxyQuickConnect from './ProxyQuickConnect'
export default ProxyQuickConnect
